export default function (t, e) {
  return t === e.length - 1;
}
;